import React, { useState } from 'react';
import classnames from 'classnames';

import './style.scss';

const Anchor = ({ word, explanation }) => {

  const [OpenAnchor, setOpenAnchor] = useState(true);

  const toggleAnchor = () => {
    setOpenAnchor(!OpenAnchor);
  };

  return (
    <div className={classnames('Anchor', { Anchor__open: OpenAnchor })}>
      <div className="Anchor__word" onClick={toggleAnchor}>
        <div className="Anchor__icon">
          <div className="icon icon-info icon-variant-0" />
        </div>
        <div className="Anchor__body">
          {word}
        </div>
        <div className="Anchor__arrow">
          <div className="icon icon-chevron-right icon-variant-0" />
        </div>
      </div>

      <div className="Anchor__description">
        <div className="Anchor__icon">
          <div className="icon icon-info icon-variant-0" />
        </div>
        <div className="Anchor__body">
          {explanation}
        </div>
      </div>
    </div>
  );
};

export default Anchor;
